export default __webpack_public_path__ + "static/media/home_banner.77d81590.png";